var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.612 2.21445C16.4346 2.07611 16.216 2.00098 15.991 2.00098C15.766 2.00098 15.5474 2.07611 15.37 2.21445L1 13.4194L2.243 14.9914L4 13.6214V26.0004C4.00106 26.5306 4.21211 27.0387 4.58695 27.4135C4.9618 27.7883 5.46989 27.9994 6 28.0004H26C26.5301 27.9994 27.0382 27.7883 27.413 27.4135C27.7879 27.0387 27.9989 26.5306 28 26.0004V13.6304L29.757 15.0004L31 13.4284L16.612 2.21445ZM18 26.0004H14V18.0004H18V26.0004ZM20 26.0004V18.0004C19.9995 17.4702 19.7886 16.9618 19.4136 16.5868C19.0387 16.2119 18.5303 16.001 18 16.0004H14C13.4697 16.001 12.9613 16.2119 12.5864 16.5868C12.2114 16.9618 12.0005 17.4702 12 18.0004V26.0004H6V12.0624L16 4.27245L26 12.0724V26.0004H20Z",
    fill: "#3C38CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonHome);
export default __webpack_public_path__ + "static/media/carbon_home.e24ea7a6090244717c748cf3b4302399.svg";
export { ForwardRef as ReactComponent };